import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getGstTransactionDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.GST_TRANSACTION_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.GST_TRANSACTION_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export default function* adminReportSaga() {
    yield all([
        takeEvery(actions.GST_TRANSACTION_DETAILS_START, getGstTransactionDetails)
    ]);
}